import { all } from 'redux-saga/effects';

import appSyncSaga from './modules/appSync/saga';
import importExportSaga from './modules/importExport/saga';
import appSaga from './containers/App/saga';
import authSaga from './containers/Auth/saga';
import userProfileSaga from './containers/UserProfile/saga';
import pagesHistorySaga from './containers/PagesHistory/saga';
import auditSaga from './containers/PagesHistory/AuditLog/saga';
import badgesSaga from './containers/Badges/saga';

function* rootSaga() {
  yield all([
    appSaga(),
    authSaga(),
    pagesHistorySaga(),
    userProfileSaga(),
    appSyncSaga(),
    importExportSaga(),
    auditSaga(),
    badgesSaga(),
  ]);
}

export default rootSaga;



// WEBPACK FOOTER //
// ./src/sagas.ts